(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/debug-tools/assets/javascripts/components/add-broken-item-to-last-searched.js') >= 0) return;  svs.modules.push('/components/casino-react/debug-tools/assets/javascripts/components/add-broken-item-to-last-searched.js');
'use strict';

const dispatchGameToLastSearched = svs.components.casino_react.casinoStore.utils.lastSearched.dispatchGameToLastSearched;
const CardType = svs.components.casino_react.common.constants.CardType;
const AddBrokenItemToLastSearched = _ref => {
  let type = _ref.type;
  if (!svs.core.detect.feature('ft-casino-debug-tools')) {
    return null;
  }
  if (type === CardType.GAME) {
    return React.createElement("button", {
      onClick: () => {
        dispatchGameToLastSearched("".concat(CardType.GAME, "_i-am-broken-game"));
      },
      tabIndex: -1,
      type: "button"
    }, "L\xC4GG TILL TRASIGT SPEL");
  }
  if (type === CardType.PROVIDER) {
    return React.createElement("button", {
      onClick: () => {
        dispatchGameToLastSearched("".concat(CardType.PROVIDER, "_i-am-broken-provider"));
      },
      tabIndex: -1,
      type: "button"
    }, "L\xC4GG TILL TRASIG LEVERANT\xD6R");
  }
  if (type === CardType.CATEGORY) {
    return React.createElement("button", {
      onClick: () => {
        dispatchGameToLastSearched("".concat(CardType.CATEGORY, "_i-am-broken-category"));
      },
      tabIndex: -1,
      type: "button"
    }, "L\xC4GG TILL TRASIG KATEGORI");
  }
};
setGlobal('svs.components.casino_react.debug_tools.components.AddBrokenItemToLastSearched', AddBrokenItemToLastSearched);

 })(window);